// extracted by mini-css-extract-plugin
export var carrierNotice = "_kf-5";
export var carrierNoticePlaceholder = "_kf-6";
export var deliveryRow = "_kf-c";
export var fixedHeight = "_kf-4";
export var freightLogo = "_kf-b";
export var fullWidth = "_kf-3";
export var priceColumn = "_kf-7";
export var radioSelected = "_kf-9";
export var radioUnselected = "_kf-8";
export var selectedOption = "_kf-2";
export var selectedOptionContainer = "_kf-1";
export var selection = "_kf-0";
export var tallSkeletonText = "_kf-a";